const s = {
  'next': 'Next',
  'prev': 'Prev',
  'select...': 'Select...',
  'brand': 'Brand',
  'select a date': 'Select a date',
  'select hour': 'Select hour',
  'day': 'Day',
  'time': 'Time',
  'location': 'Location',
  'your data': 'Your data',
  'date and time': 'Date and time',
  'num people': 'Number of people',
  'err num people': 'Select how many people',
  'workshop list': 'Workshop list',
  'signup': 'Signup',

  'first name': 'First name',
  'last name': 'Last name',
  'name': 'Name',
  'appointment day': 'Appointment day',
  'email': 'Email',
  'phone': 'Phone',
  'phone_scemi': 'Phone',
  'phone_scemi_placeholder': '333 12345678',
  'prefix_scemi_placeholder': 'i.e. +39',
  'whatsapp': 'WhatsApp',
  'appointment type': 'Appointment type',
  'preferred contact': 'Preferred contact',
  'preferred language': 'Preferred language',
  'product category': 'Product category',
  'notes': 'Notes',
  'subscribe to newsletter': 'Subscribe to newsletter',
  'slot unavailable': 'The chosen time slot is not available anymore',
  'choose another time slot': 'Select another time slot',
  'confirm': 'Confirm',
  'sending': 'Sending',
  'appointment confirmed': 'Thank you for booking!<br>You will shortly receive a confirmation email.',

  'onsite': 'In Store',
  'online': 'Online',

  'italian': 'Italian',
  'english': 'English',
  'french': 'French',
  'chinese': 'Chinese',
  'russian': 'Russian',
  'japanese': 'Japanese',
  'korean': 'Korean',

  'Abbigliamento Bambino': 'Children\'s Clothing',
  'Abbigliamento Donna': 'Women\'s Clothing',
  'Abbigliamento Uomo': 'Men\'s Clothing',
  'Accessori': 'Accessories',
  'Arredamento': 'Interior design',
  'Borse': 'Bags',
  'Calzature': 'Shoes',
  'Calzature Donna': 'Women\'s Shoes',
  'Calzature Uomo': 'Men\'s Shoes',
  'Fragranze': 'Fragrances',
  'Gioielleria': 'Jewellery',
  'Occhiali Da Sole': 'Sunglasses',
  'Orologi': 'Watches',
  'Pelletteria': 'Leather goods',
  'Pellicceria': 'Fur Goods',

  'fill all fields': 'Fill all the required fields (*) to continue',
}

export default s;